export const TREND_DETAIL_AGE_GENDER_SET = {
  'all': "전체",
  'female': "여성",
  'male': "남성",
  '10f': "10대 여성",
  '20f': "20대 여성",
  '30f': "30대 여성",
  '40f': "40대 여성",
  '50f': "50대+ 여성",
  '10m': "10대 남성",
  '20m': "20대 남성",
  '30m': "30대 남성",
  '40m': "40대 남성",
  '50m': "50대+ 남성",
}

export const TREND_DETAIL_CUSTOM_AGE_SET = {
  'all': "전체",
  'female': "전체",
  'male': "전체",
  '10f': "10대",
  '20f': "20대",
  '30f': "30대",
  '40f': "40대",
  '50f': "50대이상",
  '10m': "10대",
  '20m': "20대",
  '30m': "30대",
  '40m': "40대",
  '50m': "50대이상",
}

export const TREND_DETAIL_CUSTOM_GENDER_SET = {
  'all': "전체",
  'female': "여성",
  'male': "남성",
  '10f': "여성",
  '20f': "여성",
  '30f': "여성",
  '40f': "여성",
  '50f': "여성",
  '10m': "남성",
  '20m': "남성",
  '30m': "남성",
  '40m': "남성",
  '50m': "남성",
}